module.exports = __webpack_public_path__ + "static/media/calendar.a11994cc.svg";